module.exports = __webpack_public_path__ + "img/maru2_bg.b3872e72.jpg";